import React from 'react';

import css from './step-indicator.module.css';

export default function StepIndicator({
  steps,
  currentStep = 1,
}: {
  steps: { name: string }[];
  currentStep?: number;
}) {
  function step(index: number) {
    return (
      <div
        key={`step${index}`}
        className={`${css['step']}
          ${currentStep === index ? css['current'] : ''}
          ${currentStep > index ? css['done'] : ''}`}
      >
        <span className={css['index']}>{index + 1}</span>
        <span className={css['name']}>{steps[index].name}</span>
      </div>
    );
  }

  function spacer(index: number) {
    return (
      <div key={`spacer${index}`} className={css['spacer']}>
        <div className={css['dots']} />
      </div>
    );
  }

  function stepsAndSpacers() {
    let elements = [];
    // half indexes are for spacers
    for (let index = 0.0; index < steps.length - 0.5; index += 0.5) {
      if (index === Math.floor(index)) {
        elements.push(step(index));
      } else {
        elements.push(spacer(index));
      }
    }
    return elements;
  }

  return <div className={css['step-indicator']}>{stepsAndSpacers()}</div>;
}
